export default __webpack_public_path__ + "static/media/hunterclose.d194dc64.mp3";